import { AnnouncementBar } from './AnnouncementBar';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CartDrawer } from './CartDrawer';
import { FreeGiftPicker } from './FreeGiftPicker';
import { ExitIntentPopup } from './ExitIntentPopup';
import { Toaster } from 'sonner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-lum-bg text-lum-text">
      <AnnouncementBar />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <CartDrawer />
      <FreeGiftPicker />
      <ExitIntentPopup />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
};
